import { Divider } from '@televet/kibble-ui';
import React from 'react';

const MessageComposerDivider = (): JSX.Element => {
  return <Divider orientation="vertical" height="34px" mx={1} />;
};

export default MessageComposerDivider;
